import { Component } from "solid-js";

export const Header: Component = () =>
{
    return (
        <div></div>
    );
}